import { useState, useEffect } from 'react';

/**
 * Custom hook to manage page-specific welcome modals
 * Shows a guide modal on first visit to each page
 * @param {string} pageKey - Unique identifier for the page (e.g., 'recipes', 'workouts')
 * @returns {object} - { showWelcome, closeWelcome }
 */
export const usePageWelcome = (pageKey) => {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    try {
      const storageKey = `welcomeSeen_${pageKey}`;
      const hasSeenWelcome = localStorage.getItem(storageKey);
      
      if (!hasSeenWelcome) {
        // Small delay for better UX
        const timer = setTimeout(() => {
          setShowWelcome(true);
        }, 500);
        return () => clearTimeout(timer);
      }
    } catch (e) {
      console.error('Failed to check welcome status');
    }
  }, [pageKey]);

  const closeWelcome = () => {
    try {
      const storageKey = `welcomeSeen_${pageKey}`;
      localStorage.setItem(storageKey, 'true');
      setShowWelcome(false);
    } catch (e) {
      console.error('Failed to save welcome status');
      setShowWelcome(false);
    }
  };

  return { showWelcome, closeWelcome };
};
